import React from 'react';
import './AverageResponse.css';
import logComponent from '../../common/logComponent';
import AverageResponse from './AverageResponse';
import { CardAverageResponseProvider } from '../../contexts/CardAverageResponseContext';
 
export default function AverageResponseCard({ moduleDescription }) {
  if (logComponent('AverageResponseCard')) { console.debug('AverageResponseCard rendered'); }


  return (
    <CardAverageResponseProvider>
      <AverageResponse moduleDescription={moduleDescription} />
    </CardAverageResponseProvider>
  );
}